import { css } from 'styled-components';

const button = css`
  color: var(--dark-navy);
  background-color: var(--green);
  border: 1px solid var(--green);
  border-radius: 50px;
  font-size: var(--fz-xs);
  font-family: var(--font-mono);
  font-weight: 600;
  line-height: 1;
  text-decoration: none;
  padding: 1.25rem 1.75rem;
  transition: var(--transition);
  letter-spacing: 0.05em;

  &:hover,
  &:focus-visible {
    outline: none;
    background-color: transparent;
    color: var(--green);
    transform: translateY(-3px);
  }
  &:after {
    display: none !important;
  }
`;

const mixins = {
  flexCenter: css`
    display: flex;
    justify-content: center;
    align-items: center;
  `,

  flexBetween: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,

  link: css`
    display: inline-block;
    text-decoration: none;
    text-decoration-skip-ink: auto;
    color: inherit;
    position: relative;
    transition: var(--transition);

    &:hover,
    &:focus-visible {
      color: var(--green);
      outline: 0;
    }
  `,

  inlineLink: css`
    display: inline-block;
    position: relative;
    color: var(--green);
    transition: var(--transition);

    &:hover,
    &:focus-visible {
      color: var(--green);
      outline: 0;
      & > * {
        color: var(--green) !important;
        transition: var(--transition);
      }
    }
  `,

  button,

  smallButton: css`
    color: var(--dark-navy);
    background-color: var(--green);
    border: 1px solid var(--green);
    border-radius: 50px;
    padding: 0.75rem 1.25rem;
    font-size: var(--fz-xs);
    font-family: var(--font-mono);
    font-weight: 600;
    line-height: 1;
    text-decoration: none;
    transition: var(--transition);
    letter-spacing: 0.05em;

    &:hover,
    &:focus-visible {
      outline: none;
      background-color: transparent;
      color: var(--green);
      transform: translateY(-3px);
    }
    &:after {
      display: none !important;
    }
  `,

  bigButton: css`
    color: var(--dark-navy);
    background-color: var(--green);
    border: 1px solid var(--green);
    border-radius: 50px;
    padding: 1.25rem 1.75rem;
    font-size: var(--fz-sm);
    font-family: var(--font-mono);
    font-weight: 600;
    line-height: 1;
    text-decoration: none;
    transition: var(--transition);
    letter-spacing: 0.05em;

    &:hover,
    &:focus-visible {
      outline: none;
      background-color: transparent;
      color: var(--green);
      transform: translateY(-3px);
    }
    &:after {
      display: none !important;
    }
  `,

  boxShadow: css`
    box-shadow: 0 10px 30px -15px var(--navy-shadow);
    transition: var(--transition);

    &:hover,
    &:focus-visible {
      box-shadow: 0 20px 30px -15px var(--navy-shadow);
    }
  `,

  fancyList: css`
    padding: 0;
    margin: 0;
    list-style: none;
    font-size: var(--fz-lg);
    li {
      position: relative;
      padding-left: 28px;
      margin-bottom: 10px;
      &:before {
        content: '→';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
      }
    }
  `,

  resetList: css`
    list-style: none;
    padding: 0;
    margin: 0;
  `,
};

export default mixins;
